// Utility to refresh user profile data

import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

export const refreshUserProfile = async (userId) => {
  try {
    console.log('Refreshing user profile for:', userId);
    
    const userDoc = await getDoc(doc(db, 'users', userId));
    
    if (userDoc.exists()) {
      const userData = userDoc.data();
      console.log('Refreshed user data:', userData);
      return userData;
    } else {
      console.error('User document not found');
      return null;
    }
  } catch (error) {
    console.error('Error refreshing user profile:', error);
    return null;
  }
};

export const checkSalaryData = async (userId) => {
  try {
    const userData = await refreshUserProfile(userId);
    
    if (userData?.teacherProfile?.salary) {
      console.log('✅ Salary data found:', userData.teacherProfile.salary);
      return userData.teacherProfile.salary;
    } else {
      console.log('❌ No salary data found');
      console.log('Teacher profile exists:', !!userData?.teacherProfile);
      console.log('Full user data:', userData);
      return null;
    }
  } catch (error) {
    console.error('Error checking salary data:', error);
    return null;
  }
};